import { styled } from '@styles';

export const Wrapper = styled.div``;

export const SelectAddressHeader = styled.h3`
  font-weight: 500;
`;
